export default __webpack_public_path__ + "static/media/thyroidlogo.7ce9c4a6.jpg";